import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import Inquiry from "./sections/Inquiry";
import PurchaseOffer from "./sections/PurchaseOffer";
import Pricing from "./sections/Pricing";
import WhyJoinFreshMart from "./sections/WhyJoinFreshMart";
import TrustAndDisclaimer from "./sections/TrustAndDisclaimer";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OurStory />
      <WhyJoinFreshMart />
      <PurchaseOffer />
      <Pricing />
      <Inquiry />
      <TrustAndDisclaimer />
      <Cta />
      <Footer />
    </div>;
}